import { proxy } from 'valtio'
import type { Socket } from '~/modules/SDK/socket2/Socket'

export const useSymbolStore = proxy({ currentSymbol: 'TX-1' as Socket.SymbolString })
